export type Tone =
  | "brand"
  | "neutral"
  | "info"
  | "azure"
  | "violet"
  | "success"
  | "warning"
  | "destructive";

export const TONE_TEXT: Record<Tone, string> = {
  brand: "text-brand-strong",
  neutral: "text-foreground",
  azure: "text-azure-strong",
  info: "text-info-strong",
  violet: "text-violet-strong",
  success: "text-success-strong",
  warning: "text-warning-strong",
  destructive: "text-destructive-strong",
};

export const TONE_DOT: Record<Tone, string> = {
  brand: "bg-brand",
  neutral: "bg-muted-foreground",
  azure: "bg-azure",
  info: "bg-info-dot",
  violet: "bg-violet-dot",
  success: "bg-success-dot",
  warning: "bg-warning-dot",
  destructive: "bg-destructive-dot",
};

export const TONE_BACKGROUND: Record<Tone, string> = {
  brand: "bg-brand-tint",
  neutral: "bg-muted",
  azure: "bg-azure-bg",
  info: "bg-info-bg",
  violet: "bg-violet-bg",
  success: "bg-success-bg",
  warning: "bg-warning-bg",
  destructive: "bg-destructive-bg",
};

export const TONE_ROW_BACKGROUND: Record<Tone, string> = {
  brand: "bg-brand-tint/40",
  neutral: "bg-muted/40 hover:bg-muted/40",
  info: "bg-info-bg/40 hover:bg-info-bg/40",
  azure: "bg-azure-bg/40 hover:bg-azure-bg/40",
  violet: "bg-violet-bg/40 hover:bg-violet-bg/40",
  success: "bg-success-bg/40 hover:bg-success-bg/40",
  warning: "bg-warning-bg/40 hover:bg-warning-bg/40",
  destructive: "bg-destructive-bg/40 hover:bg-destructive-bg/40",
};

export const TONE_BORDER: Record<Tone, string> = {
  brand: "border-brand/30",
  neutral: "border-border",
  azure: "border-azure/30",
  info: "border-info/30",
  violet: "border-violet/30",
  success: "border-success/30",
  warning: "border-warning/30",
  destructive: "border-destructive/30",
};

export const TONE_STROKE: Record<Tone, string> = {
  brand: "stroke-brand",
  neutral: "stroke-muted-foreground",
  azure: "stroke-azure",
  info: "stroke-info",
  violet: "stroke-violet",
  success: "stroke-success",
  warning: "stroke-warning",
  destructive: "stroke-destructive",
};

export const TONE_FILL: Record<Tone, string> = {
  brand: "fill-brand",
  neutral: "fill-muted-foreground",
  azure: "fill-azure",
  info: "fill-info",
  violet: "fill-violet",
  success: "fill-success",
  warning: "fill-warning",
  destructive: "fill-destructive",
};

export const TONE_AREA: Record<Tone, string> = {
  brand: "fill-brand/10",
  neutral: "fill-muted-foreground/10",
  azure: "fill-azure/10",
  info: "fill-info/10",
  violet: "fill-violet/10",
  success: "fill-success/10",
  warning: "fill-warning/10",
  destructive: "fill-destructive/10",
};

export const TONE_TINT: Record<Tone, string> = {
  brand: "bg-brand-tint text-brand-strong",
  neutral: "bg-muted text-muted-foreground",
  azure: "bg-azure-bg text-azure-strong",
  info: "bg-info-bg text-info-strong",
  violet: "bg-violet-bg text-violet-strong",
  success: "bg-success-bg text-success-strong",
  warning: "bg-warning-bg text-warning-strong",
  destructive: "bg-destructive-bg text-destructive-strong",
};

export const TONE_SOLID: Record<Tone, string> = {
  brand: "bg-brand text-brand-foreground",
  neutral: "bg-foreground text-background",
  azure: "bg-azure text-azure-foreground",
  info: "bg-info text-info-foreground",
  violet: "bg-violet text-violet-foreground",
  success: "bg-success text-success-foreground",
  warning: "bg-warning text-warning-foreground",
  destructive: "bg-destructive text-destructive-foreground",
};

export const TONE_SURFACE: Record<Tone, string> = {
  brand: "border-brand/30 bg-brand-tint text-brand-strong",
  neutral: "border-border bg-muted text-foreground",
  azure: "border-azure/30 bg-azure-bg text-azure-strong",
  info: "border-info/30 bg-info-bg text-info-strong",
  violet: "border-violet/30 bg-violet-bg text-violet-strong",
  success: "border-success/30 bg-success-bg text-success-strong",
  warning: "border-warning/30 bg-warning-bg text-warning-strong",
  destructive:
    "border-destructive/30 bg-destructive-bg text-destructive-strong",
};

export const TONE_FIELD: Record<Exclude<Tone, "brand">, string> = {
  neutral: "border-border text-foreground focus:border-border-strong",
  azure: "border-azure/50 text-azure-strong focus:border-azure",
  info: "border-info/50 text-info-strong focus:border-info",
  violet: "border-violet/50 text-violet-strong focus:border-violet",
  success: "border-success/50 text-success-strong focus:border-success",
  warning: "border-warning/50 text-warning-strong focus:border-warning",
  destructive:
    "border-destructive/50 text-destructive-strong focus:border-destructive",
};
